
import { ref } from 'vue'

export const useStepper = (config) => {
  const step = ref(config?.step ?? 1)
  const attempted = ref(new Set())

  const nextStep = (delta = 1) => { step.value += delta }
  const prevStep = (delta = 1) => { step.value -= delta }
  const markAttempted = (n) => attempted.value.add(n)
  const wasAttempted = (n) => attempted.value.has(n)

  return { step, nextStep, prevStep, markAttempted, wasAttempted }
}
